"use strict";Object.defineProperty(exports, "__esModule", {value: true});











/* G6: the recipients one Add adds, from any mix of sources: patients picked
 * from the directory, new patients typed in, and an uploaded CSV with its
 * row edits. Rev 31 v2: each dialog's confirm sends them in one
 * AddCampaignRecipients request, straight to the campaign. */

















































 const EMPTY_PENDING = { files: [], rows: [] }; exports.EMPTY_PENDING = EMPTY_PENDING

 const EMPTY_NEW_PATIENT = {
  FirstName: '', LastName: '', Phone: '', Email: '', MRN: '', DOB: '',
}; exports.EMPTY_NEW_PATIENT = EMPTY_NEW_PATIENT

let nextId = 0
 const pendingId = (prefix) => `${prefix}-${++nextId}`; exports.pendingId = pendingId

/* Blank values are left out, so they read as missing: the variable's default
 * applies, or the row is flagged. Others are stored as typed. */
const filledValues = (values) =>
  Object.fromEntries(Object.entries(values).filter(([, v]) => v.trim() !== ''))

/* Variables this Add can carry values for: the campaign's and every file's
 * mapped ones. Values typed for a variable whose file
 * was since removed or remapped are left out (the server refuses them). */
 const declaredVariables = (p, campaignVariables) => new Set([
  ...campaignVariables,
  ...p.files.flatMap(f => f.mapping.flatMap(m => m.Destination === 'variable' ? [m.Variable] : [])),
]); exports.declaredVariables = declaredVariables

const declaredValues = (values, declared) =>
  Object.fromEntries(Object.entries(filledValues(values)).filter(([k]) => declared.has(k)))

const filledFields = (fields) =>
  Object.fromEntries(
    Object.entries(fields).map(([k, v]) => [k, v.trim()]).filter(([, v]) => v !== ''),
  ) 

 const toRecipientRow = (r, declared) => r.kind === 'pick'
  ? { PatientKey: r.patient.PatientKey, Values: declaredValues(r.values, declared) }
  : { NewPatient: filledFields(r.fields), Values: declaredValues(r.values, declared) }; exports.toRecipientRow = toRecipientRow

/* The request's sources: one rows source first (when there are rows), so the
 * table lists picks and new patients above the files; then the files in list
 * order. */
 const toSources = (p, declared) => [
  ...(p.rows.length ? [{ Kind: 'rows' , Rows: p.rows.map(r => exports.toRecipientRow.call(void 0, r, declared)) }] : []),
  ...p.files.map(f => ({
    Kind: 'file' ,
    FileKey: f.fileKey,
    Mapping: f.mapping,
    ...(f.excludedRows.length || f.skipMissingFor.length
      ? { Exclude: { Rows: f.excludedRows, MissingFor: f.skipMissingFor } }
      : {}),
  })),
]; exports.toSources = toSources

 const toRequest = (
  campaignKey,
  p,
  campaignVariables,
) => ({
  CampaignKey: campaignKey,
  Sources: exports.toSources.call(void 0, p, exports.declaredVariables.call(void 0, p, campaignVariables)),
}); exports.toRequest = toRequest

 const updateFile = (
  p,
  id,
  update,
) => ({ ...p, files: p.files.map(f => f.id === id ? update(f) : f) }); exports.updateFile = updateFile

 const VARIABLE_NAME = /^[a-z0-9_]{1,64}$/; exports.VARIABLE_NAME = VARIABLE_NAME

/* A header or typed label as a variable name (a-z, 0-9, _), like the server's slug. */
 const slugVariable = (s) =>
  s.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 64); exports.slugVariable = slugVariable
